import styled from 'styled-components/macro';
import { BlueTextLink } from '../../../../components/LinkStyles';

export const RequiresActionP = styled.p`
  margin-left: 15px;
`;

export const CustomBlueTextLink = styled(BlueTextLink)`
  font-size: 1.3rem;
`;
